export default __webpack_public_path__ + "static/media/homeAbout.a4e78fcd.jpg";